import angular from 'angular';

/**
 * Helper service with Globals variables that can be injected
 * in app.config and app.run. Helps to avoid circular dependencies.
 */
const module = angular.module('whyline.services.globals', []);

class GlobalsService {

  constructor() {
    this.CurrentPlace = null;
    this.CurrentOrganization = null;
    this.SingleOrganization = null;
    this.SinglePlace = null;
    this.EnterpriseType = 'whyline';
    this.CurrentLanguage = 'en';
    this.CurrentLine = null;
    this.HttpError = null;
  }

  SetCurrentLanguage(lang) {
    this.CurrentLanguage = lang || 'en';
  }

  SetEnterpriseType(type) {
    this.EnterpriseType = type || 'whyline';
  }

  SetCurrentOrganization(organization) {
    this.CurrentOrganization = organization || null;
  }

  SetSingleOrganization(singleOrganization) {
    //User has only one organization
    this.SingleOrganization = singleOrganization || null;
  }

  SetSinglePlace(singlePlace) {
    //User has only one place
    this.SinglePlace = singlePlace || null;
  }

  SetCurrentPlace(place) {
    this.CurrentPlace = place || null;
  }

  SetCurrentLine(line) {
    this.CurrentLine = line || null;
  }

  SetHttpError(error) {
    this.HttpError = error || null;
  }
}

module.exports = module.service('GlobalsService', GlobalsService);
